import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import ClientApp from "@/pages/ClientApp";
import GroupApp from "@/pages/GroupApp";
import PlatformLogin from "@/pages/PlatformLogin";
import PlatformApp from "@/pages/PlatformApp";
import Dashboard from "@/pages/Dashboard";
import KDSPage from "@/pages/KDSPage";
import POSPage from "@/pages/POSPage";
import Login from "@/pages/Login";
import PaymentReturn from "@/pages/PaymentReturn";
import SetOwnPin from "@/components/common/SetOwnPin";

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="min-h-screen bg-[#0C1713] grid place-items-center">
        <div className="w-8 h-8 rounded-full border-2 border-[#C69C4A] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.pin_temporary) return <SetOwnPin user={user} pinLen={user.pin_len || 4} onDone={() => window.location.reload()} />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/restaurant/:slug/table/:tableNumber" element={<ClientApp />} />
          <Route path="/payment/success" element={<PaymentReturn mode="success" />} />
          <Route path="/payment/cancel" element={<PaymentReturn mode="cancel" />} />
          <Route path="/restaurant/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/manager" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/pos" element={<ProtectedRoute><POSPage /></ProtectedRoute>} />
          <Route path="/kds" element={<ProtectedRoute><KDSPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/group" element={<ProtectedRoute><GroupApp /></ProtectedRoute>} />
          <Route path="/platform/login" element={<PlatformLogin />} />
          <Route path="/platform" element={<PlatformApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
